import { LocalStorage } from 'quasar'
import { getSubdomainName } from '@/utils/get-subdomain'

/* This runs when the app gets loaded for the first time or when a refresh happens */
export function bootActions(store) {
  const subdomainName = getSubdomainName()

  const authorizeTokenKey = `${subdomainName}_authorization`
  const token = LocalStorage.getItem(authorizeTokenKey)
  let user = LocalStorage.getItem(`${subdomainName}_user`)

  if (typeof user === 'string') {
    user = JSON.parse(user)
  }

  store.commit('updateTenant', subdomainName)
  store.commit('updateUser', user)
  store.commit('updateAccessToken', token)
}

export function isTokenInLocalStorage() {
  const subdomainName = getSubdomainName()

  const authorizeTokenKey = `${subdomainName}_authorization`
  const token = LocalStorage.getItem(authorizeTokenKey)

  return !!token
}
